import { Box } from "@mui/material";
import { PrimaryButton } from "../../components/ui/Button";
import { ArrowForward } from "@mui/icons-material";
import { ReactComponent as CheckoutGreenIcon } from "../../assets/icons/auth/checked-green-80.svg";
import { useNavigate } from "react-router-dom";
import service from "../../services/api/service";
import {
  setStatusPopup,
} from "../../services/redux/slices/statusPopupSlice"; 
import { useDispatch, useSelector } from "react-redux";
import {
  authSelector,
  clearAuth,
  clearPasswordType,
  setUserAuth,
  setUserBusinessType,
  setUserLoanCategory,
  setUserPermission,
  setUserProfileData,
} from "../../services/redux/slices/authSlice";
import { ROUTES } from "../../routes/routerConfig";
import { decrypt, encrypt } from "../../utils/crypto";
import { setIsBypassLogin, setIsEligibilityCheckSubmitted } from "../../services/redux/slices/stepperDynamicFormSlice";
import axiosInstance from "../../services/api/interceptor/interceptor";
import { setSelectedIndex, setTabType } from '../../services/redux/slices/tabsSlice';

type props = {
  setNextStep: (step: string) => void,
}

const PasswordCreated = ({ setNextStep }: props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { passwordType } = useSelector(authSelector);
  const newUserData: any = useSelector((state: any) => state.auth.userProfile);
  const handleSubmit = async () => {
    try {
      const encryptedKey = encrypt(localStorage.getItem("mobile"));
      const resp: any = await axiosInstance.post("api/v1/user-lead/bypass-login", {
        key: encryptedKey,
        role: "applicant",
        key2: encryptedKey,
      });
      if (resp.data?.status === "success") {
        const data: any = JSON.parse(decrypt(resp?.data?.data))

        dispatch(setUserProfileData(data?.user));
        dispatch(setUserPermission(data?.permission));
        dispatch(setUserBusinessType(data?.businessType.length > 0 ? data?.businessType?.[0] : {}));
        dispatch(setUserLoanCategory(data?.result));
        dispatch(setUserAuth(data?.token));
        localStorage.removeItem("mobile");
        localStorage.removeItem("applicationNo");
      } else {
        // Handle error (show snackbar, etc.)
        console.error(resp.data?.message || "Bypass login failed");
      }
    } catch (error: any) {
      // Handle error (show snackbar, etc.)
      console.error(error?.response?.data?.message || "Bypass login failed");
    }
  };

  return (
    <Box>
      <Box className="main-wrapper">
        <Box sx={{ textAlign: "center", width: "100%" }}>
          <CheckoutGreenIcon />
        </Box>
        <Box className="head-section">
          <Box className="heading">Password successfully created.</Box>
          <Box className="sub-heading">
            Now you can securely access your account
          </Box>
        </Box>
        <PrimaryButton
          type="button" // Change type to "submit"
          onClick={handleSubmit}
          fullWidth
          endIcon={<ArrowForward color="inherit" fontSize="small" />}
        >
          {passwordType?.includes("forgot") && passwordType !== null
            ? "Login"
            : "Continue"}
        </PrimaryButton>
      </Box>
    </Box>
  );
};

export default PasswordCreated;